/**
 * Convert the input value a test id.
 */
export function toTestId(value) {
    return String(value).trim().replace(/\s+/g, '-').toLowerCase();
}
//# sourceMappingURL=toTestId.js.map